// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default (_: any) => 0
